import { LandingPageLoadEvent } from '@/services/analytics/events';
import { AdobePageLoadEvent } from './adobe-page-load';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { WebPageDetails } from '../models';

export class AdobeLandingPageLoadEvent extends AdobePageLoadEvent {
  constructor(event: LandingPageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      pageType: event.pageDetails?.embeddableProperties?.pageType || 'landing',
      siteSection: event.pageDetails?.embeddableProperties?.siteSection || 'landing',
      name: event.pageDetails?.embeddableProperties?.pageName || 'landing',
      pageViews: { value: 1 },
    } as WebPageDetails);

  }
}
